import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  getAllPaymentProviders,
} from "../../../redux/payment/paymentActions";
import errorHandler from '../../../handlers/errorHandler';

export default React.forwardRef(function OpayPlugin(
  { email, amount, onSuccess, onClose, reference, payment_type, cancelUrl, returnUrl },
  ref
) {
  const dispatch = useDispatch();
  const { allProviders } = useSelector((state) => state.payment);
  const publicKey = allProviders?.opay_key;

  useEffect(() => {
    dispatch(getAllPaymentProviders());
    // eslint-disable-next-line
  }, []);

  React.useImperativeHandle(ref, () => ({
    getAmount_Reference: (amount, reference) => {
      initializePayment(amount, reference);
    },
  }));

  console.log('cancelUrl', cancelUrl);
  console.log('returnUrl', returnUrl);
  const cancelLink = window.location.origin + cancelUrl;
  console.log('cancelLink', cancelLink);


  const initializePayment = async (paymentAmount, paymentReference) => {
    // Generate a fresh unique reference ID to prevent duplicate order errors
    const uniqueRef = paymentReference + `${Date.now()}`;

    // Calculate amount in major units (multiply by 100 for OPay)
    const amountInMajorUnits = Math.round((paymentAmount || amount) * 100).toString();

    const cancelLink = window.location.origin + cancelUrl;
    const returnLink = window.location.origin + returnUrl;

    // Build the exact payload object
    const payload = {
      amount: {
        currency: "NGN",
        total: amountInMajorUnits // OPay uses major units
      },
      // callbackUrl: window.location.origin + "/profile/payments""/cart/guest-checkout/success",
      callbackUrl: returnLink,
      country: "NG",
      expireAt: 15,
      merchantName: "Ogwugo Limited",
      product: {
        description: payment_type || "Payment",
        name: payment_type || "Order Payment"
      },
      reference: uniqueRef,
      // returnUrl: window.location.href, // Returns the user back to this tab
      returnUrl: returnLink, // Returns the user back to this tab
      cancelUrl: cancelLink,
      userInfo: {
        userEmail: email || "customer@example.com",
        userName: "Customer"
      },
      payMethod: "",
    };

    // Address the CORS block by passing the request through a proxy for local testing
    const targetUrl = "https://sandboxapi.opaycheckout.com/api/v1/international/cashier/create";
    const liveUrl = "https://api.opaycheckout.com/api/v1/international/cashier/create"
    const stagingUrl = "https://testapi.opaycheckout.com/api/v1/international/payment/create";

    // check if were are live or staging and set the url accordingly
    const proxiedUrl = process.env.NODE_ENV === "development" ?
      `https://corsproxy.io/?${encodeURIComponent(targetUrl)}` :
      (process.env.REACT_APP_APP_ENV === "staging" ? stagingUrl : liveUrl);

    try {
      const response = await axios.post(proxiedUrl, payload, {
        headers: {
          "Content-Type": "application/json",
          "MerchantId": allProviders?.opay_merchant_id,
          "Authorization": `Bearer ${publicKey}`
        }
      });



      const result = response.data;

      if (result.code === "00000" && result.data?.cashierUrl) {
        // Automatically open the cashier checkout screen in a new tab
        window.open(result.data.cashierUrl, '_blank');

        // Don't call onSuccessFunction here - wait for user to complete payment
        // The user will return via returnUrl after payment
      } else {
        console.error(`%c[OPay Error ${result.code}]: ${result.message}`, "color: red; font-weight: bold;");
        errorHandler({ response }, true);
      }
    } catch (error) {
      console.error("%c[Network Error] Request failed completely:", "color: red; font-weight: bold;");
      console.error(error);
      errorHandler(error, true);
    }
  };
});
